export const GET_STORERANKING = 'store/storeRanking/GET_STORERANKING'
export const SET_DASHBOARDPARAMS = 'store/storeRanking/SET_DASHBOARDPARAMS'
export const GET_DASHBOARDATA = 'store/storeRanking/GET_DASHBOARDATA'


// WEBPACK FOOTER //
// ./src/actionTypes/StoreRanking/StoreRanking.js